export class LoginRedirectService {
  public static buildLoginUrl(): string {
    const target = window.location.pathname + window.location.search + window.location.hash;
    if (!target || target === '/portfolio') {
      return '/login';
    }
    return `/login/${encodeURIComponent(target)}`;
  }
}
